import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { WorkplaceGridObject } from '@it2go/types';

@Injectable()
export class ToolsMissingProceduresPageStore extends ComponentStoreV2Factory {

    gridData = this.data.getMissingProcedures;
    workplaces = computed<WorkplaceGridObject>(() => this.data.getWorkplaces()?.items || []);

    public services = computed(() => {
        return this.globalGlobalStore.organizationStore.servicesInContext().filter((it) =>
            this.globalGlobalStore.isAllowedForService('work.read', it.id)() && it.expertise?.code === '926',
        );
    });

}
